import { Flex, Paper, Text, Box, Divider } from "@mantine/core";
import { IconPackage } from "@tabler/icons-react";
import { ProductServiceType } from "@/components/shared/constants/general.const";

interface ProductsServicesTabProps {
  company: any;
  isMatchedView?: boolean;
}

export default function ProductsServicesTab({ company }: ProductsServicesTabProps) {
  const productServices = company?.productServices || [];

  const products = productServices.filter((item: any) => item.type === ProductServiceType.PRODUCT);
  const services = productServices.filter((item: any) => item.type === ProductServiceType.SERVICE);

  const renderItems = (items: any[]) => (
    <Flex gap="xl" wrap="wrap">
      {items.map((item: any, index: number) => (
        <Flex key={item.id || index} direction="column" style={{ flex: "1 1 45%", minWidth: "280px", maxWidth: "50%" }}>
          <Text size="sm" c="slate.8" fw={700} mb="xs">
            {item.name || "Untitled"}
          </Text>
          <Text size="sm" style={{ lineHeight: 1.5, wordBreak: "break-word", overflow: "hidden", textAlign: "justify" }}>
            {item.description || "N/A"}
          </Text>
        </Flex>
      ))}
    </Flex>
  );

  return (
    <Paper
      p={0}
      radius="lg"
      mb="xl"
      style={{
        overflow: "hidden",
        backgroundColor: "#ebf0ff",
        boxShadow: "0 1px 3px rgba(15, 23, 42, 0.08)",
      }}
    >
      <Flex
        align="center"
        gap="sm"
        px={{ base: "md", sm: "xl" }}
        py={{ base: "md", sm: "lg" }}
        style={{ backgroundColor: "#04305c" }}
      >
        <IconPackage size={22} color="#ffc300" stroke={1.5} />
        <Text fw={700} fz="md" c="#ffc300" style={{ letterSpacing: 0.2 }}>
          Products & Services
        </Text>
      </Flex>
      <Box p={{ base: "lg", sm: "xl" }}>
        <Flex direction="column" gap="lg">
          {products.length > 0 && (
            <Box>
              <Text size="md" c="slate.8" tt="uppercase" mb="sm" fw={600}>
                PRODUCTS
              </Text>
              {renderItems(products)}
            </Box>
          )}

          {products.length > 0 && services.length > 0 && <Divider />}

          {services.length > 0 && (
            <Box>
              <Text size="md" c="slate.8" tt="uppercase" mb="sm" fw={600}>
                SERVICES
              </Text>
              {renderItems(services)}
            </Box>
          )}

          {products.length === 0 && services.length === 0 && (
            <Text size="lg" c="slate.6">
              N/A
            </Text>
          )}
        </Flex>
      </Box>
    </Paper>
  );
}
